

import React from 'react'
import { Container, Grid, Header, Icon, List, Segment } from 'semantic-ui-react'

const FooterComponent = () =>{
    return(
        <Segment inverted id="c_footer" basic>
            <Container>
                <Grid columns="equal">
                    <Grid.Column width="3">
                        <Header inverted as="h4">
                            About
                        </Header>
                        <List>
                            <List.Item as="a" href="mailto:info@solveeducation.org">Contact</List.Item>
                            <List.Item as="a" href="https://solveeducation.org/privacy-policy/">Privacy Policy</List.Item>
                            <List.Item as="a" href="https://solveeducation.org/terms-of-service/">Term of Service</List.Item>
                            <List.Item as="a" href="https://solveeducation.org/faqs/">FAQ</List.Item>
                        </List>
                    </Grid.Column>
                    <Grid.Column width="3">
                        <Header inverted as="h4">
                            Services
                        </Header>
                        <List>
                            <List.Item as="a" href="https://solveeducation.org/">Solve Education!</List.Item>
                            <List.Item as="a" href="https://dawnofcivilization.net/">Dawn of Civilization</List.Item>
                        </List>
                    </Grid.Column>
                    <Grid.Column width="3">
                        <Header inverted as="h4">
                            Contact
                        </Header>
                        <List>
                            <List.Item as="a" href="tel:+622271520541">
                                <Icon name="phone" color="orange"/> (+6222) 71520541
                            </List.Item>
                            <List.Item as="a" href="mailto:info@solveeducation.org">
                                <Icon name="envelope" color="orange"/> info@solveeducation.org
                            </List.Item>
                            <List.Item as="a" href="https://goo.gl/maps/5qVi7FfEWVUpm4uc8">
                                <Icon name="map marker" color="orange"/> Graha Padasuka Blok E7, Bandung
                            </List.Item>
                        </List>
                    </Grid.Column>
                    <Grid.Column width="1"></Grid.Column>
                    <Grid.Column width="6" textAlign="right">
                        <a href="https://www.facebook.com/solveeducation/">
                            <Icon name="facebook" size="large"/>
                        </a>
                        <a href="https://twitter.com/solveeducation">
                            <Icon name="twitter" size="large"/>
                        </a>
                        <a href="https://www.instagram.com/solveeducation/">
                        <Icon name="instagram" size="large"/>
                        </a>
                        <a href="https://www.youtube.com/channel/UCXFFHqO7BzyiaG1qt8MBhlg">
                        <Icon name="youtube" size="large"/>
                        </a>
                        <a href="https://www.linkedin.com/company/solve-education-/">
                        <Icon name="linkedin" size="large"/>
                        </a>
                    </Grid.Column>
                </Grid>
            </Container>
        </Segment>
    )
}

export default FooterComponent

